import React from 'react';
import { FolderKanban, Tag } from 'lucide-react';

import ProjectActions from './ProjectActions';
import { cn } from '@/lib/utils';
const ProjectsTable = ({
  projects,
  onOpenRollouts,
  onCreateRollout,
  onCreateAccumulative,
  canCreateRollout = true,
  canOpenRollouts = true,
}) => (
  <div className="space-y-3">
    {projects.map((project) => (
      <article
        key={project.key}
        role={canOpenRollouts ? 'button' : undefined}
        tabIndex={canOpenRollouts ? 0 : undefined}
        className={cn(
          'grid gap-4 rounded-xl border border-border/40 bg-card/20 px-4 py-4 text-left transition-all duration-200 md:grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1.2fr)] md:items-center md:gap-4',
          canOpenRollouts
            ? 'cursor-pointer hover:border-border/70 hover:bg-card/35 focus-visible:border-primary/40 focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50'
            : 'cursor-default'
        )}
        onClick={() => {
          if (canOpenRollouts) {
            onOpenRollouts(project);
          }
        }}
        onKeyDown={(event) => {
          if (
            canOpenRollouts &&
            (event.key === 'Enter' || event.key === ' ')
          ) {
            event.preventDefault();
            onOpenRollouts(project);
          }
        }}
      >
        <div className="flex min-w-0 items-start gap-3">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary">
            <FolderKanban className="h-4 w-4" />
          </div>

          <div className="min-w-0 space-y-1.5">
            <div className="flex flex-wrap items-center gap-2">
              <span className="truncate text-[16px] font-semibold tracking-[-0.01em] text-foreground">
                {project.projectName}
              </span>
            </div>
            <p className="text-[12px] leading-5 text-muted-foreground">
              {project.description}
            </p>
          </div>
        </div>

        <div className="space-y-2 md:justify-self-start">
          <div className="text-[10px] font-medium uppercase tracking-[0.16em] text-muted-foreground md:hidden">
            Version
          </div>
          <div className="inline-flex min-w-[132px] items-center gap-2 rounded-[8px] px-[10px] py-[6px]">
            <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background/70 text-muted-foreground">
              <Tag className="h-3.5 w-3.5" />
            </div>
            <div className="min-w-0">
              <div className="text-[10px] uppercase tracking-[0.05em] text-muted-foreground">
                Version
              </div>
              <div className="truncate text-[13px] font-medium text-primary">
                {project.versionName}
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-2 md:justify-self-start">
          <div className="text-[10px] font-medium uppercase tracking-[0.16em] text-muted-foreground md:hidden">
            Rollouts
          </div>
          <div className="inline-flex min-w-[156px] flex-col items-start gap-1">
            <div className="text-[11px] font-semibold uppercase tracking-[0.16em] text-foreground">
              Total
            </div>
            <div className="text-[34px] font-semibold leading-none tracking-[-0.04em] text-foreground tabular-nums">
              {project.rolloutCount}
            </div>
            <div className="text-[12px] font-medium text-foreground/80">
              Rollouts
            </div>
          </div>
        </div>

        <div className="space-y-1 md:justify-self-end md:self-center">
          <div className="text-[10px] font-medium uppercase tracking-[0.16em] text-muted-foreground md:hidden">
            Actions
          </div>
          <ProjectActions
            project={project}
            createLabel="Create Rollout"
            onCreateRollout={onCreateRollout}
            onCreateAccumulative={onCreateAccumulative}
            canCreateRollout={canCreateRollout}
          />
        </div>
      </article>
    ))}
  </div>
);

export default ProjectsTable;
